import { render } from "./OptionsTarefa.vue?vue&type=template&id=99a0b69e"
import script from "./OptionsTarefa.vue?vue&type=script&lang=js"
export * from "./OptionsTarefa.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__